import styled from 'styled-components';

const NoData = styled.div`
  margin: 3em;
  text-align: center;
`;

export default NoData;
